import React, { createContext, useContext, useState } from "react";

const dict = {
  fr: {
    app_name: "SIRH Maisonéa",
    brand: "Maisonéa",
    login: "Connexion",
    login_subtitle: "Accédez à votre SIRH de laboratoire",
    email: "Email",
    password: "Mot de passe",
    sign_in: "Se connecter",
    signing_in: "Connexion…",
    logout: "Déconnexion",
    dashboard: "Tableau de bord",
    users: "Utilisateurs",
    user_records: "Enregistrements",
    structures: "Structures",
    geography: "Géographie",
    export: "Export",
    settings: "Paramètres",
    total_users: "Utilisateurs totaux",
    active_users: "Comptes actifs",
    active_records: "Fiches actives",
    sites: "Sites",
    societes: "Sociétés",
    directions: "Directions",
    services: "Services",
    equipes: "Équipes",
    contract_by_type: "Contrats par type",
    users_by_site: "Utilisateurs par site",
    recent_activity: "Activité récente",
    search: "Rechercher…",
    filters: "Filtres",
    status: "Statut",
    all: "Tous",
    active: "Actif",
    inactive: "Inactif",
    suspended: "Suspendu",
    new: "Nouveau",
    edit: "Modifier",
    delete: "Supprimer",
    save: "Enregistrer",
    cancel: "Annuler",
    confirm: "Confirmer",
    login_placeholder: "Identifiant",
    display_name: "Nom affiché",
    first_name: "Prénom",
    last_name: "Nom",
    mail: "Email",
    employee_id: "Matricule",
    account_status: "Statut compte",
    manager: "Manager",
    site: "Site",
    service: "Service",
    title: "Intitulé",
    contract_type: "Contrat",
    time_type: "Temps",
    working_rate: "Taux",
    presence_state: "Présence",
    start_date: "Date début",
    end_date: "Date fin",
    pays: "Pays",
    regions: "Régions",
    identity: "Identité",
    profile: "Profil étendu",
    user_record: "Fiche RH",
    referentials: "Référentiels",
    demo_generator: "Générateur de données démo",
    generate: "Générer",
    reset_db: "Réinitialiser la base",
    confirm_reset: "Confirmer la réinitialisation ?",
    users_volume: "Volume d'utilisateurs",
    no_data: "Aucune donnée",
    loading: "Chargement…",
    rows_selected: "ligne(s) sélectionnée(s)",
    activate: "Activer",
    deactivate: "Désactiver",
    export_preview: "Aperçu (5 premières lignes)",
    entity: "Entité",
    separator: "Séparateur",
    encoding: "Encodage",
    download: "Télécharger",
    toggle_module: "Activer / Désactiver",
    module_config: "Configuration des modules",
    dependencies: "Dépendances",
    no_results: "Aucun résultat",
    role: "Rôle",
    new_user: "Nouveau collaborateur",
    filter_contract: "Type de contrat",
    filter_site: "Site",
  },
  en: {
    app_name: "SIRH Maisonéa",
    brand: "Maisonéa",
    login: "Sign in",
    login_subtitle: "Access your lab HRIS",
    email: "Email",
    password: "Password",
    sign_in: "Sign in",
    signing_in: "Signing in…",
    logout: "Log out",
    dashboard: "Dashboard",
    users: "Users",
    user_records: "User Records",
    structures: "Structures",
    geography: "Geography",
    export: "Export",
    settings: "Settings",
    total_users: "Total users",
    active_users: "Active accounts",
    active_records: "Active records",
    sites: "Sites",
    societes: "Companies",
    directions: "Divisions",
    services: "Services",
    equipes: "Teams",
    contract_by_type: "Contracts by type",
    users_by_site: "Users per site",
    recent_activity: "Recent activity",
    search: "Search…",
    filters: "Filters",
    status: "Status",
    all: "All",
    active: "Active",
    inactive: "Inactive",
    suspended: "Suspended",
    new: "New",
    edit: "Edit",
    delete: "Delete",
    save: "Save",
    cancel: "Cancel",
    confirm: "Confirm",
    login_placeholder: "Login",
    display_name: "Display name",
    first_name: "First name",
    last_name: "Last name",
    mail: "Email",
    employee_id: "Employee ID",
    account_status: "Account status",
    manager: "Manager",
    site: "Site",
    service: "Service",
    title: "Title",
    contract_type: "Contract",
    time_type: "Time",
    working_rate: "Rate",
    presence_state: "Presence",
    start_date: "Start date",
    end_date: "End date",
    pays: "Countries",
    regions: "Regions",
    identity: "Identity",
    profile: "Profile",
    user_record: "HR Record",
    referentials: "Referentials",
    demo_generator: "Demo data generator",
    generate: "Generate",
    reset_db: "Reset database",
    confirm_reset: "Confirm reset?",
    users_volume: "Users volume",
    no_data: "No data",
    loading: "Loading…",
    rows_selected: "row(s) selected",
    activate: "Activate",
    deactivate: "Deactivate",
    export_preview: "Preview (first 5 rows)",
    entity: "Entity",
    separator: "Separator",
    encoding: "Encoding",
    download: "Download",
    toggle_module: "Enable / Disable",
    module_config: "Module configuration",
    dependencies: "Dependencies",
    no_results: "No results",
    role: "Role",
    new_user: "New employee",
    filter_contract: "Contract type",
    filter_site: "Site",
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("sirh_lang") || "fr");
  const setLanguage = (l) => {
    setLang(l);
    localStorage.setItem("sirh_lang", l);
  };
  const t = (k) => dict[lang][k] ?? k;
  return (
    <I18nContext.Provider value={{ lang, setLanguage, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
